import * as React from 'react';

import * as styles from './FlightHeader.css';
import { NBSP, LF } from '../../../constants/symbols';
import { useInView } from '../../../hooks/useInView';

interface IFlightHeaderProps {
  controls: React.ReactNode;
  setIsHeaderControlsVisible: (isVisible: boolean) => void;
}

export const FlightHeader = ({ controls, setIsHeaderControlsVisible }: IFlightHeaderProps): React.JSX.Element => {
  const [controlsRef, isControlsInView] = useInView<HTMLDivElement>({
    threshold: 0.1,
  });

  React.useEffect(() => {
    setIsHeaderControlsVisible(isControlsInView);
  }, [isControlsInView, setIsHeaderControlsVisible]);

  return (
    <div className={styles['header-container']}>
      <div className={styles['header']}>
        <div className={styles['content']}>
          <h1 className={styles['title']}>
            Бесплатно подберём{LF}и{NBSP}поможем купить{LF}квартиру в{NBSP}новостройке
          </h1>
          <div ref={controlsRef} className={styles['controls']}>
            {controls}
          </div>
        </div>
      </div>
    </div>
  );
};
